import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';
import animator from '../../helpers/animator';
import dataModel from '../../models/DataModel';
import CopyProjectTemplatePopout from '../../components/CopyProjectTemplatePopout';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';

import './ProjectTemplateMenuPopup.scss';
import Input from '../Input';

export default class ProjectTemplateMenuPopup extends BaseComponent {
  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = {
      displayCopyPopout: false,
      projectTemplate: this.props.projectTemplate,
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
    super.componentDidMount();
    dataModel.setDisableAppBackground(true);
  }

  componentWillUnmount() {
    dataModel.setDisableAppBackground(false);
  }

  handleClick(event) {
    if (!this.state.displayCopyPopout) {
      event.stopPropagation();
    }
  }

  handleClosePopout(){
    this.props.handleClosePopup();
  }

  handleDisplayCopyPopout(e) {
    if (e) e.stopPropagation();

    const { displayCopyPopout } = this.state;
    if (displayCopyPopout) {
      this.props.handleClosePopup();
    }
    this.setState({ displayCopyPopout: !displayCopyPopout });
  }
  handleSave(e) {
    if (e) e.stopPropagation();
    const currentProjectTemplate = this.state.projectTemplate;
    if(currentProjectTemplate.name){
      const templateParam = { name: currentProjectTemplate.name, id: currentProjectTemplate.id };
      this.props.handleEditTemplateName(templateParam);
      this.props.handleUpdateProjectTypeTemplates({ ...templateParam, group_identifier: currentProjectTemplate.group_identifier }, currentProjectTemplate.project_type_id);
      this.props.handleClosePopup();
    }
  }

  handleNameChange = (event) => {
    const editedProjectTemplate = Object.assign({}, this.state.projectTemplate, { name: event.target.value });
    this.setState({ projectTemplate: editedProjectTemplate });
  }

  handleInputClick(e){
    e.stopPropagation();
  }
  handleEditKeyDown(e){
    // keycode 13, 40 and 27 are for Enter, Arrow Down and Escape respectively
    if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleProjectTemplateUpdate();
    }
    else if (e.keyCode == 27) {
      this.handleEditCancel();
    }
  }
  handleSetTitleElement(element){
    this.titleInput = element;
    if (this.titleInput) {
      this.titleInput.focus();
    }
  }

  render() {
    if (!this.state.projectTemplate) {
      return null;
    }

    //255 is the width of the copy projectTemplate popout. Would be better to use ref but cannot with the way we inject this component into the DOM
    const { cardRect } = this.props;
    let left = cardRect.left + cardRect.width - 46;

    let menuPopup = (
      <div className="menu-popout" style={{ left: left }}>
        <div className={'menu-item'} onClick={this.handleSave}>Save</div>
        <div className={'menu-item'} onClick={this.handleDisplayCopyPopout}>Copy</div>
        <div className={'menu-item'} onClick={this.handleClosePopout}>Cancel</div>
      </div>
    );

    return (
      <div id="project-template-menu-popout" className={'project-template-menu-popup'} onClick={this.handleClick}>
        <div className={'project-template-menu-overlay'}
          style={
            { left: 30, top: cardRect.top - 4, width: cardRect.width - 60 }}
          ref={(element) => this.projectTemplateElement = element}>
            <div className="project-type-edit" ref={el => this.nameEditRef = el}>
            <div className="project-type-edit-name-container">
            <Input className="project-type-edit-name" value={this.state.projectTemplate.name} onChange={this.handleNameChange} onClick={this.handleInputClick}
              onKeyDown={this.handleEditKeyDown} ref={(element) => this.handleSetTitleElement (element)} />
            </div>
            </div>
          {/* <div className="template-name">{this.state.projectTemplate.name}</div> */}
          <div className="menu-open-indicator" />
          { !this.state.displayCopyPopout && menuPopup }
          <CopyProjectTemplatePopout 
            projectTemplate={this.state.projectTemplate}
            handleClosePopup={this.handleDisplayCopyPopout}
            displayCopyPopout={this.state.displayCopyPopout}
            handleAddCopiedTemplate={this.props.handleAddCopiedTemplate}
            currentUser={this.props.currentUser}
            currentCompany={this.props.currentCompany}
          />
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/ProjectTemplateMenuPopup/index.js